module.exports = __webpack_public_path__ + "img/call_history_on.90074ab1.png";